// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1eQzM","calendarButtons":"ClockData_calendarButtons__1zxON"};